<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="v" class="page" epub:type="pagebreak" id="pv" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocf"><a class="xref" href="#/chifranklin0006#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0007#ch01"><b>1</b>  Between the Commonplace and the Sublime</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0008#ch02"><b>2</b>  The Birth of Brainstorming</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0009#ch03"><b>3</b>  Creativity as Self-Actualization</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0010#ch04"><b>4</b>  Synectics at the Shoe</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0011#ch05"><b>5</b>  The Creative Child</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0012#ch06"><b>6</b>  Revolution on Madison Avenue</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0013#ch07"><b>7</b>  Creativity Is Dead . . .</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0014#ch08"><b>8</b>  From Progress to Creativity</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0015#ch09"><b>9</b>  Long Live Creativity</a></p>
<p class="toc"><a class="xref" href="#/chifranklin0016#conc">Conclusion: What Is to Be Done?</a></p>
<p class="tocbmf"><a class="xref" href="#/chifranklin0017#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chifranklin0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chifranklin0019#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-franklin-0005.vue?5d9b7df4